export const getErrorMessage = (formErrors, input) => {
    const error = formErrors.find(error => error.input === input);
    return error ? `* ${error.message}` : null;
};

export const defaultErrorField = {
    imageUrl: "Please provide an image URL.",
    quoteText: "Quote text is required.",
    articleTitle: "Your article must have a title.",
    articleBody: "You need to include an article body.",
    articleImageUrl: "Please provide an article image.",
};